import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const ProductsReport = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/products");
      setData(res.data);
      console.log("Product Report:", res.data);
    } catch (err) {
      console.error("Error loading product report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (loading || !data)
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" />
        <p className="mt-2">Loading product report...</p>
      </div>
    );

  return (
    <div className="container my-4">
      <h2 className="fw-bold text-primary mb-4">
         Products Performance Report
      </h2>

      {/* 🔹 کارت‌های خلاصه آماری */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card text-center text-white bg-primary shadow-sm">
            <div className="card-body">
              <h6>Avg Sales per Product</h6>
              <h3>{data.avgSalesPerProduct.toFixed(2)}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center text-white bg-success shadow-sm">
            <div className="card-body">
              <h6>Top Selling Count</h6>
              <h3>{data.topSelling?.length}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center text-white bg-danger shadow-sm">
            <div className="card-body">
              <h6>Out of Stock</h6>
              <h3>{data.lowStock?.length}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 نمودار محصولات پرفروش */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="mb-3 text-secondary">Top Selling Products</h5>
          {data.topSelling.length > 0 ? (
            <div style={{ width: "100%", height: 300 }}>
              <ResponsiveContainer>
                <BarChart data={data.topSelling}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="title" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="sold" fill="#0d6efd" name="Units Sold" />
                  <Bar dataKey="revenue" fill="#198754" name="Revenue ($)" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <p>No best-selling products found.</p>
          )}
        </div>
      </div>

      {/* 🔹 جدول محصولات اتمام موجودی */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="mb-3 text-danger">Out of Stock / Low Inventory</h5>
          {data.lowStock.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Product</th>
                    <th>Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {data.lowStock.map((p) => (
                    <tr key={p._id}>
                      <td>{p.title}</td>
                      <td>{p.stock}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>All products are sufficiently stocked </p>
          )}
        </div>
      </div>

      {/* 🔹 محصولات بدون فروش */}
      <div className="card shadow-sm mb-5">
        <div className="card-body">
          <h5 className="mb-3 text-muted">Unsold Products</h5>
          {data.lowSelling.length > 0 ? (
            <ul className="list-group">
              {data.lowSelling.map((p) => (
                <li key={p._id} className="list-group-item">
                  {p.title}
                </li>
              ))}
            </ul>
          ) : (
            <p>All products have at least one sale </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsReport;
